module.exports = __webpack_public_path__ + "images/vectorFooterImage.6eec0aca.svg";